<div class="message-box" [ngClass]="{ 'warning': type === MessageBoxType.Warning, 'icon': hasIcon }">
    <mat-icon *ngIf="hasIcon" class="material-icons-outlined md-18">info</mat-icon>
    <h1>{{ title }}</h1>
    <div class="content">
        {{ message }}
    </div>
</div>